import { useContext, useEffect, useRef, useState } from "react";
import {useFetch} from "../../../api/FetchApiData";
import { UserContext } from "../../../../AppContextProvider";
import './paypal.css';
import { useNavigate, useParams } from "react-router-dom";

function Paypal({orArticlesRef,panier,prices,User,setNotif=()=>{}}) {  
    const paypal = useRef();
    let price = useRef(prices.total);
    let order = useRef({...panier,articles:orArticlesRef.current,prices:prices,email:User.email,ville:'Ville'});
    const navigator = useNavigate();
    const fetchData = useFetch();

    useEffect(()=>{price.current = prices.total;
        order.current = {...panier,articles:orArticlesRef.current,prices:prices,email:User.email,ville:'Ville'};
     },[prices,panier,orArticlesRef.current])

    useEffect(()=>{
        try{
        window.paypal.Buttons({
            createOrder:async (data,actions,error) =>{
                let paypal_id = undefined;
                await fetchData.PostData({mode:'paypal',articles:orArticlesRef.current,mount:price.current, action:'CREATE'},'payment/').then((result)=>{
                    console.log(result);
                    if(result.result)
                    {paypal_id = result.paypal_order.id;}
                    else{setNotif('echec');}
                }).catch(()=>{setNotif('echec')});
                return paypal_id
            },
            onApprove: async (data,actions)=>{
                await fetchData.PostData({mode:'paypal',mount:price.current, action:'CAPTURE', paypal_id:data.orderID},'payment/').then((result)=>{
                    if(result.result)
                    {
                        navigator(`/payment/result/${result.status}/${result.order_id}`);
                    }
                    else{setNotif('echec');}
                }).catch(()=>{setNotif('echec')});
            },
            onError:(error)=>{
                //console.log(error);
                setNotif('echec')
            }
        }).render(paypal.current)
    }
    catch{}
    },[])

    return (
        <div className="paypaldiv" style={{zIndex:'1'}}>
            <div ref={paypal} />
        </div>
    );
}

export default Paypal; 